import { useTheme } from '../../../hooks/useTheme';

const WHATSAPP_ADVISOR =
  'https://wa.me/18495388899?text=Hola%20InnoFlex!%20Quiero%20hablar%20con%20un%20asesor%20sobre%20InnoFlex%20Odontolog%C3%ADa.';

interface DentalCTAProps {
  onRequestDemo: () => void;
}

export default function DentalCTA({ onRequestDemo }: DentalCTAProps) {
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const accentText = isLight ? '#0f766e' : '#14b8a6';

  const ink = isLight ? '#0a1628' : '#ffffff';
  const sub = isLight ? 'rgba(10,22,40,0.72)' : 'rgba(255,255,255,0.58)';

  return (
    <section
      className="py-16 md:py-20 px-4 sm:px-6"
      style={{
        background: isLight
          ? 'linear-gradient(135deg, #f6fafd 0%, #eef8f6 100%)'
          : 'linear-gradient(135deg, #04101f 0%, #071b2e 100%)',
        borderTop: isLight ? '1px solid rgba(10,22,40,0.08)' : '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <div
          className="w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-6"
          style={{
            background: 'linear-gradient(135deg, rgba(6,182,212,0.18) 0%, rgba(20,184,166,0.18) 100%)',
            border: '1px solid rgba(6,182,212,0.30)',
          }}
        >
          <i className="ri-tooth-line text-2xl" style={{ color: '#14b8a6' }} aria-hidden="true" />
        </div>

        <h2
          className="font-heading text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 leading-tight"
          style={{ color: ink }}
        >
          Tu clínica puede operar con menos desorden y{' '}
          <span style={{ color: accentText }}>mayor control.</span>
        </h2>
        <p
          className="font-body text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mb-9"
          style={{ color: sub }}
        >
          Agenda una demostración y conoce cómo InnoFlex puede ayudarte a controlar cada paciente,
          tratamiento, cobro y oportunidad de crecimiento.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5">
          <button
            type="button"
            onClick={onRequestDemo}
            className="w-full sm:w-auto flex items-center justify-center gap-2.5 px-8 py-3.5 rounded-full font-body text-sm font-extrabold transition-all duration-200 hover:scale-[1.03] active:scale-[0.97] cursor-pointer whitespace-nowrap"
            style={{
              background: 'linear-gradient(135deg, #06b6d4 0%, #14b8a6 100%)',
              color: '#04101f',
              boxShadow: '0 8px 26px rgba(6,182,212,0.30)',
            }}
          >
            <i className="ri-calendar-schedule-line text-base" aria-hidden="true" />
            Solicitar demostración
          </button>

          <a
            href={WHATSAPP_ADVISOR}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-full sm:w-auto flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-full font-body text-sm font-bold transition-all duration-200 hover:scale-[1.03] cursor-pointer whitespace-nowrap border"
            style={{
              borderColor: 'rgba(37,211,102,0.35)',
              backgroundColor: 'rgba(37,211,102,0.10)',
              color: '#25D366',
            }}
          >
            <i className="ri-whatsapp-line text-base" aria-hidden="true" />
            Hablar con un asesor
          </a>
        </div>
      </div>
    </section>
  );
}
